<template>
    <div id="clubDogErrors">
        <table class="kgr-table kgr-table--striped table-groups kgr-row">
            <thead>
                <tr class="kgr-table_row">
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ tName }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ tChipNumber }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ tErrorMessage }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="error in errorList"
                    :key="error.entity.id"
                    class="kgr-table_row"
                >
                    <td class="kgr-table__cell">
                        {{ error.entity.name }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ error.entity.chipNumber }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ error.errorMessage }}
                    </td>
                    <td class="kgr-table__cell">
                        <a
                            :href="showDog(error.entity.id)"
                            target="_blank"
                        >{{ tShowDog }}</a>
                    </td>
                </tr>
            </tbody>
        </table>
        <button
            v-if="hasMoreErrors"
            class="kgr-button kgr-button--secondary"
            @click="showMore"
        >
            {{ tShowMore }}
        </button>
    </div>
</template>

<script>
export default {
    props: {
        errors: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            numberOfResults: 10,
        };
    },
    computed: {
        errorList() {
            return this.errors.slice(0, this.numberOfResults);
        },
        hasMoreErrors() {
            return this.errors.length > this.errorList.length;
        },
        tName() {
            return this.$t('Name');
        },
        tChipNumber() {
            return this.$t('Chipnummer');
        },
        tErrorMessage() {
            return this.$t('Lists.actions.errors.errorMessage');
        },
        tShowDog() {
            return this.$t('Lists.actions.errors.showDog');
        },
        tShowMore() {
            return this.$t('Lists.actions.errors.showMore');
        },
    },
    methods: {
        showDog(id) {
            return `/backend/clubs/dogs/${id}/show`;
        },
        showMore() {
            this.numberOfResults += 10;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  #clubDogErrors {
    max-height: 450px;
    overflow-y: auto;
}
</style>
